import axios from 'axios';
const { SERVER_BASE_URL } = require("../config/config")

export const uploadResume = async (file, prompt) => {
    try {
        const formData = new FormData();
        formData.append('pdf', file);
        formData.append('prompt', prompt)
        console.log("called" + `  ${SERVER_BASE_URL}/ai`)

        const config = {
            headers: {
              'Authorization': `Bearer ${JSON.parse(localStorage.getItem('authId'))}`,
            }
          };
        let { data } = await axios.post(`${SERVER_BASE_URL}/ai`,formData,config)

        console.log("data", data)
        return data;

    } catch (error) {
        console.log("error", error)

    }


}

